const verification_record = {
    not_found: 'Registro de verificação não encontrado.',
    permission_denied: 'Permissão negada, por favor, autentique-se novamente.',
    not_supported_for_google_one_tap: 'Esta API não suporta o Google One Tap.',
};
export default Object.freeze(verification_record);
